import React from 'react';
import heading__image from '../img/watermarked-08af277b-3fb0-4920-a9b5-d40e667a2567.png';

function TheHeading() {
  return (
    <div className="heading">
      <div className="heading__image">
        <img src={heading__image} alt="Barbora" />
      </div>
      <h1 className="heading__logo">Barbora</h1>
      <a className="heading__email" href="mailto:majernikova.barbora@gmail.com">majernikova.barbora@gmail.com</a>
    </div>
  );
}

export default TheHeading;